import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=cff0ed72&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=ts"
export * from "./MainTitle.vue?vue&type=script&lang=ts"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=cff0ed72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff0ed72",
  null
  
)

export default component.exports